import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from './index.module.scss'
import { useBetRecordList, useQueryBetRecordTotal, useQueryVenueList } from "./hooks/useBetOrderRecords";
import VenueFilter from "./compoments/venueFilter";
import BettingRecords from "./compoments/bettingRecords";
import BetStatistics from "./compoments/betStatistics";
import LoadingUI from "@/compoments/loadingUI";
import PaginationTo from "./compoments/paginationTo";
import DateFilter from "./compoments/dateFilter";
import FadeIn from "@/compoments/fadeIn";
import { useTranslation } from "react-i18next";


export type BetRecordFilter = {
  startAt: string;
  endAt: string;
  venueId: number;
  page: number;
  pageSize: number;
  queryFlag: number;
  flag: number;
  _refresh?: number; // 可选字段，支持强制刷新
};


const BetOrderRecords = ()=>{
  const { t } = useTranslation('record')
  // 初始筛选条件
  const getInitialFilters = () => ({
    startAt: ut.getDateString(0), // 开始日期今天
    endAt: ut.getDateString(0), // 结束日期
    venueId: 0,  // 全部场馆
    page: 1,  // 当前页码
    pageSize: 5, // 每页记录数
    queryFlag: 5,
    flag: 5,
  })
  
  // 状态管理更新筛选条件
  const initialFilters = getInitialFilters()
  const [filterInputs, setFilterInputs] = useState<BetRecordFilter>(initialFilters)
  const [filters, setFilters] = useState<BetRecordFilter>(initialFilters)

  // 获取投注记录数据
  const { list, totalPage, totalRecord, isLoading } = useBetRecordList(filters)

  // 获取投注记录统计数据
  const { data: totalData, isLoading: isLoadingTotal } = useQueryBetRecordTotal(filters)

  // 点击查询按钮后：更新过滤条件并重置为第一页
  const handleSearch = () => {
    setFilters({ 
      ...filterInputs, 
      page: 1,
      _refresh: Date.now(), // 这行确保 filters 每次都是“新对象”
    });
  };
  
  // 获取场馆数据
  const{ data: venueList, isLoading: loadingVenueList } = useQueryVenueList({}) || {}
  // 场馆筛选数据
  const venueOptions = useMemo(()=>{
    const options =[{label: t('all'), value: 0}]
    const mapped = venueList?.data?.map((v)=>{
      return {
        label: v.zhName,
        value: v.id
      }
    }) || []
    return options.concat(mapped); 
  },[venueList])

  // 扁平化投注记录
  const flatList = useMemo(() => {
    return list.flatMap(item =>
      (item.data ?? []).map(record => ({
        ...record,
        day: item.day
      }))
    );
  }, [list]);
  // 如果需要就按天处理flatList
  // const groupedList = useMemo(() => {
  //   const map = {};
  //   flatList.forEach(item => {
  //     if (!map[item.day]) map[item.day] = [];
  //     map[item.day].push(item);
  //   });
  //   return Object.entries(map).map(([day, data]) => ({ day, data }));
  // }, [flatList]);

  // ✅ 加入真实高度缓存逻辑
  const contentRef = useRef<HTMLDivElement>(null)
  const [contentHeight, setContentHeight] = useState<number | undefined>()
  useEffect(() => {
    if (!isLoading && contentRef.current) {
      const height = contentRef.current.getBoundingClientRect().height
      setContentHeight(height)
    }
  }, [isLoading, flatList, totalData])
  
  return (
    <FadeIn>
    <div className={styles.betOrderRecords}>
      
      <div className={styles.title}>{t('bettingRecord')}</div>

      {/* 日期筛选 */}
      <DateFilter 
        value={{startAt: filters.startAt, endAt: filters.endAt}}
        onChange={(start, end) =>
          setFilters(prev => ({
            ...prev,
            startAt: start,
            endAt: end,
            _refresh: Date.now(), // 总是刷新，即使时间一样
          }))
        }
      />

      <div className={styles.venue}>
        {/* 场馆筛选 */}
        <VenueFilter
          value={filterInputs}
          venueOptions={venueOptions}
          onChange={(venueId) => setFilterInputs(prev => ({ ...prev, venueId }))}
        />
        {/* 查询按钮 */}
        <button onClick={handleSearch}>{t('query')}</button>
      </div>

      <LoadingUI data={ list } loading={ isLoading } height={contentHeight}>
      <div ref={contentRef}>
        {/* 投注统计数据 */}
        <BetStatistics data={totalData} />
        {/* 显示投注记录 */}
        <BettingRecords list={flatList} />
      </div>
      </LoadingUI>
      
      {/* 分页器 */}
      {totalRecord >0 && <PaginationTo 
        current={filters.page}
        total={totalRecord}
        pageSize={filters.pageSize}
        onChange={(page) => {
          setFilters(prev => ({ 
            ...prev, 
            page ,
          }));
        }}
      />}
    </div>
    </FadeIn>
  )
}

export default BetOrderRecords